import _ from "lodash";
import { apiFields } from "./_utils";
import * as usersApi from "js/api/usersApi";
import { useUserSessionStore } from "./v2/userSessionStore";

export const createUsersStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {}, // username -> user obj
	isFetching: false,

	fetch: async () => {
		setIn({ isFetching: true });
		let res = await usersApi.getUsers();

		// PATCH: until we fix users with empty usernames being allowed to be saved in the backend
		res = res.filter((user) => user.username);
		const data = _.keyBy(res, "username");
		setIn({ data, isFetching: false, lastFetched: Date.now() });
	},
});

export const createRestrictedUsersStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: [], // usernames

	fetch: async () => {
		setIn({ isFetching: true });
		let res = await usersApi.getRestrictedUsers();

		// PATCH: until we fix users with empty usernames being allowed to be saved in the backend
		res = res.filter((user) => user); // truthy check;

		setIn({ data: res, isFetching: false, lastFetched: Date.now() });
	},
});

export const createClassroomUsersStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: [], // usernames
	// exception users are members of a classroom who are not considered to be students
	exceptionUsers: [],

	fetch: async (classroomSourceId) => {
		setIn({ isFetching: true });
		const users = await usersApi.getClassroomUsers(classroomSourceId);

		let exceptionUsers = users["excluded_users"].map((u) => u.username);
		let res = users["filtered_users"];

		// PATCH: until we fix users with empty usernames being allowed to be saved in the backend
		res = res.filter((user) => user); // truthy check;
		exceptionUsers = exceptionUsers.filter((user) => user);

		// sort might not be needed, it was in backend before...
		res.sort((a, b) => (a.fname && b.fname ? a.fname.localeCompare(b.fname) : a.username.localeCompare(b.username)));
		set({ users: { ...get().users, data: _.keyBy(res, "username") } });
		const data = res.map((u) => u.username);
		setIn({ data, isFetching: false, lastFetched: Date.now(), exceptionUsers });
	},

	fetchCurrentClassroom: async (classroomSourceId) => {
		return get().classroomUsers.fetch(classroomSourceId || useUserSessionStore.getState().getActiveGroup());
	},
});

export const selectUnrestrictedUsers = (state) => {
	const unrestrictedUsernames = _.difference(Object.keys(state.users.data), state.restrictedUsers.data);
	return Object.values(_.pick(state.users.data, unrestrictedUsernames));
};

export const selectClassroomUsersFull = (state) => {
	return Object.values(_.pick(state.users.data, state.classroomUsers.data));
};

export const selectClassroomUsersMapped = (state) => _.pick(state.users.data, state.classroomUsers.data);

export const selectUsersFull = (state, usernames) => _.pick(state.users.data, usernames);

export const getUserDetail = (userName, includeGroups, includeClassrooms, includeRestrictedCheck) => {
	return usersApi.getUserDetail(userName, includeGroups, includeClassrooms, includeRestrictedCheck);
};
